import { miotechHost, resourceCDNHost } from 'constants/cdn';
import { ROUTER_COMPANY_LIST, ROUTER_DATA_COLLECTION_PLATFORM, ROUTER_RISK_TRACKING, ROUTER_RISK_TRACKING_LIST_COMPANY, ROUTER_ROOT, ROUTER_SCREENING } from 'constants/router';
import { HIDE_MIO_LOGO_ORGS } from 'constants/user';
import { css, cx } from '@emotion/css';
import { flex1, flexWrap } from 'styles/template-style';
import LayoutSearchCompany from 'layouts/main/layout-search-company';
import { FC, useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { get } from 'lodash';
import useRedux from 'hooks/useRedux';
import { ReactComponent as GviWhiteLogo } from '@assets/hsbc/gvi-white.svg';
import { ReactComponent as GviBlackLogo } from '@assets/hsbc/gvi-logo.svg';
import { getLocale } from '@miotech/shared';
import TrialQuota from './trial-quota';
import UserCenter from './user-center';
import DropdownPanel from './dropdown-panel';
import UserRole from './user-role';
import NavigationItem from './navigation-item';

const MainLayout: FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const { pathname } = useLocation();
  const language = getLocale();
  const basicInfo = get(window, '__user__.basicInfo') || {};
  const { selector: { resourceList, }, } = useRedux(s => s.userRole);
  const isHSBC = useMemo(() => resourceList?.find((item: any) => item.routePath === ROUTER_COMPANY_LIST)?.selected, [resourceList]);
  const isHABC = useMemo(() => resourceList?.find((item: any) => item.routePath === ROUTER_RISK_TRACKING)?.selected, [resourceList]);
  const hideLogo = useMemo(() => basicInfo.organization && HIDE_MIO_LOGO_ORGS.includes(basicInfo.organization), [
    basicInfo.organization,
  ]);
  const Panel = useMemo(() => {
    switch (true) {
      case isHSBC:
        return <NavigationItem
          to={ROUTER_COMPANY_LIST}
          label="ESG Performance Assessment"
          isActive={pathname === ROUTER_COMPANY_LIST}
        />;
      case isHABC:
        return <>
          <NavigationItem
            to={`${ROUTER_DATA_COLLECTION_PLATFORM}/listed`}
            label="Data Collection Platform"
            isActive={pathname.startsWith(ROUTER_DATA_COLLECTION_PLATFORM)}
          />
          <NavigationItem
            to={ROUTER_RISK_TRACKING_LIST_COMPANY}
            label="Risk Tracking"
            isActive={pathname.startsWith(ROUTER_RISK_TRACKING)}
          />
        </>;
      default:
        return pathname !== ROUTER_ROOT && <DropdownPanel />;
    }
  }, [isHABC, isHSBC, pathname]);

  const Logo = useMemo(() => {
    switch (true) {
      case isHSBC:
      case isHABC:
        return (<div className='gvi-logo'>
          {
            language === 'zh-CN' || language === 'zh-HK' ?
              <img width={58} src={`${resourceCDNHost}/images/gvi-cebb8c.svg`} alt="gvi-logo" />
              :
              <GviWhiteLogo style={{ width: 40 }} />
          }
        </div>);
      default:
        return <Link
          to={ROUTER_ROOT}
          className={cx('gvi-logo', {
            active: pathname === ROUTER_ROOT,
          })}
        >
          {
            language === 'zh-CN' || language === 'zh-HK' ?
              <img width={58} src={`${resourceCDNHost}/images/gvi-cebb8c.svg`} alt="gvi-logo" />
              :
              <GviWhiteLogo style={{ width: 40 }} />
          }
        </Link>;
    }
  }, [isHABC, isHSBC, language, pathname]);
  return (
    <div className={styleMainLayout}>
      <div className={styleNav}>
        {
          !hideLogo && (
            <a href={miotechHost} className={flexWrap}>
              {
                language === 'zh-CN' || language === 'zh-HK' ? (
                  <img width={50} src={`${resourceCDNHost}/images/miotech-ad119c.svg`} alt="miotech-logo" />
                ) : (
                  <GviBlackLogo style={{ width: 72 }} />
                )
              }
            </a>
          )
        }
        {Logo}
        {Panel}
        {[ROUTER_SCREENING].includes(pathname) && <LayoutSearchCompany />}
        <div className={flex1} />
        <TrialQuota />
        <UserRole />
        <UserCenter />
      </div>
      {children}
    </div>
  );
};
const styleMainLayout = css`
  padding-top: 48px;
`;
const styleNav = css`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 24px;
  background: #121927;
  border-bottom: 1px solid #2d3446;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  z-index: 16;
  .gvi-logo {
    padding: 4px 12px;
    border-radius: 20px;
    cursor: pointer;
    margin: 0 24px 0 32px;
    display: flex;
    align-items: center;
    &.active {
      background: rgba(255, 255, 255, 0.1);
    }
  }

  img {
    vertical-align: middle;
  }
`;


export default MainLayout;

